module.exports = __webpack_public_path__ + "h5/img/summer-img-3.5c964cd9.png";